<template>
  <div>
    <div class="p-6 bg-eds mb-4 rounded-12px">
      <h2 class="fsize18 text-black font-semibold">Partner Details:</h2>
      <h2 class="fsize16 text-black font-semibold">
        <img
          src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/ba.png"
          alt="image"
          class="avatar-imgw"
        />
        {{ partnerName }}
      </h2>
      <h2
        class="fsize16 text-black font-semibold mt-2"
        v-if="partnerName === ''"
      >
        <p>
          You haven't been paired with a partner yet. For help, please reach out
          to
          <a
            :href="`mailto:support@brained.app?subject=Need%20a%20Partner&body=Hello%20Team,%0d%0aI'm%20looking%20to%20team%20up%20with%20someone%20.%20Can%20I%20get%20a%20partner%20assigned%0d%0a%0d%0aRegards%20,%0d%0a${selectedProject.projectName}`"
            >support@brained.app</a
          >
        </p>
      </h2>
      <h2 class="text-xl font-bold text-black mt-3">
        Got new project requirements
      </h2>
      <p class="text-md font-medium text-gray mt-2">
        Get them BR<span class="col-ffc1">AI</span>NED! Create a new project
        scope and tell us about additional project requirements.
      </p>

      <vs-button
        @click="handlescope('builder-scope')"
        variant="primary"
        class="font-semibold rounded-full fsize12 py-3 my-3 w-full sm-fsize14"
      >
        Scope New Requirements
      </vs-button>
    </div>
    <div class="flex items-center gap-2">
      <div class="relative">
        <small class="fsize12 text-dark font-medium">Select Version</small>

        <el-select
          v-model="selectedTasklist"
          placeholder="Select"
          value-key="_id"
          class="mt-2"
        >
          <el-option
            v-for="item in taskList"
            :key="item.value._id"
            :label="item.text"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="relative">
        <small class="fsize12 text-dark font-medium">Select Sub-Version</small>

        <el-select
          v-model="selectedSubTasklist"
          placeholder="Select"
          value-key="_id"
          class="mt-2"
        >
          <el-option
            v-for="item in selectedTasklist.subTasklistVersion"
            :key="item._id"
            :label="item.versionNumber"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <div class="pt-6">
      <div
        class="elshadow rounded-lg mb-4"
        :class="[
          item.id === selectedRoute.id ? 'bg-f5f5f5 shadow-none' : 'bg-white',
          selectedProjectDetails.projectStatus == 'Customization'
            ? 'cursor-pointer'
            : item.id == '01' || item.id == '02' || item.id == '03'
            ? 'cursor-pointer'
            : 'opacity-dis',
        ]"
        v-for="(item, index) in cards"
        :key="'item -' + index"
        @click="handleClick(item)"
      >
        <div class="flex items-center px-4 py-2">
          <div class="flex gap-3 items-center w-full">
            <div class="w-3/12">
              <img
                :src="item.image"
                class="object-contain w-20 h-20"
                alt="banh"
              />
            </div>
            <div class="flex w-9/12">
              <div class="w-8/12">
                <h3 class="col-4f fsize14 font-semibold mb-0">
                  {{ item.title }}
                </h3>
              </div>

              <div class="w-4/12 flex justify-end">
                <div class="" v-if="item.title === 'Business Analyst'">
                  <p class="font-medium fsize12 text-center">
                    {{
                      selectedProjectDetails.BA_manHrs
                        ? selectedProjectDetails.BA_manHrs
                        : 0
                    }}/5
                  </p>
                  <p class="font-medium fsize12">hours</p>
                </div>
                <div class="" v-if="item.title === 'User Experience'">
                  <p class="font-medium fsize12 text-center">
                    {{
                      selectedProjectDetails.UX_manHrs
                        ? selectedProjectDetails.UX_manHrs
                        : 0
                    }}/15
                  </p>
                  <p class="font-medium fsize12">hours</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import { mapState } from "vuex";

export default {
  data() {
    return {
      cards: [
        {
          id: "01",
          title: "Schedule a Call",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/ba.png",
          route: "builder-PM",
        },
        {
          id: "02",

          title: "User Stories",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/pm.png",
          route: "builder-BA",
        },
        {
          id: "03",

          title: "Wireframe",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/ux.png",
          route: "builder-UX",
        },

        // {
        //   id: "04",

        //   title: "Developer1",
        //   image:
        //     "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/dev.png",
        //   route: "developer-one",
        // },

        // {
        //   id: "06",

        //   title: "Developer2",
        //   image:
        //     "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/dev.png",
        //   route: "developer-two",
        // },
        // {
        //   id: "07",

        //   title: "Developer3",
        //   image:
        //     "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/dev.png",
        //   route: "developer-three",
        // },

        {
          id: "05",

          title: "Quality Check",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/qa.png",
          route: "builder-QA",
          // route: "coming",
        },
        // {
        //   id: "08",

        //   title: "Cloud",
        //   image:
        //     "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/cloud.png",
        //   route: "coming",
        // },
      ],
      options: "",
      selectedTasklist: "",
      selectedSubTasklist: "",
      taskList: [],
      selectedRoute: "",
      partnerName: "",
      partnerEmail: "",
      partnerPhoneno: "",
      projectData: [],
    };
  },

  watch: {
    selectedTasklist(newValue) {
      this.selectedSubTasklist = "";
      this.$store.commit("design/SET_SELECTED_SPRINT", newValue);
    },
    selectedSubTasklist(newValue) {
      if (newValue) {
        console.log(newValue, "222222");
        this.$store.commit("design/SET_SELECTED_SUB_SPRINT", newValue);
        this.getPages();
      }
    },
  },
  methods: {
    async getProject() {
      try {
        let payload = {
          projectId: this.selectedProject._id,
        };
        const { data } = await Axios.post(
          process.env.VUE_APP_BASE_API + "uibuilder/getProject",
          payload
        );
        this.projectData = data.data;
        this.partnerName = this.projectData[0].hasOwnProperty("projectPartner")
          ? this.projectData[0].projectPartner.name
          : "";
        this.partnerEmail = this.projectData[0].hasOwnProperty("projectPartner")
          ? this.projectData[0].projectPartner.email
          : "";
        this.partnerPhoneno = this.projectData[0].hasOwnProperty(
          "projectPartner"
        )
          ? this.projectData[0].projectPartner.phoneno
          : "";
      } catch (error) {
        console.log(error);
      }
    },
    async getPages() {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await this.$store.dispatch(
            "builder/getPages",
            {
              projectId: this.selectedProject._id,
              projectName: this.selectedProject.projectName,
              tasklistID: this.selectedSprint._id,
              taskListIdSub: this.selectedSubSprint._id,
            },
            {
              headers: {
                "community-name": this.selectedProject.projectName,
              },
            }
          );
          console.log(data, "pages");
          this.components = data.data.map((x) => ({ ...x, Hrs: 0 }));
          this.$store.commit("design/SET_COMPONENTS", data.data);
          this.$store.commit(
            "design/SET_SELECTED_COMPONENT",
            this.components[0]
          );
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
    handlescope(name) {
      this.$router.push({ name: name });
    },
    handleClick(item) {
      if (this.selectedProjectDetails.projectStatus == "Customization") {
        this.selectedRoute = item;
        this.$router.push({ name: item.route });
      } else {
        if (item.id == "01" || item.id == "02") {
          this.selectedRoute = item;
          this.$router.push({ name: item.route });
        }
      }
    },

    async getTaskList() {
      return new Promise(async (resolve, reject) => {
        try {
          // const { data } = await Repository.post(
          //   "/zoho/projects/tasks/tasklist"
          // );
          // console.log(data);

          const { data } = await this.$store.dispatch("builder/getTasklist", {
            // projectName: "testApplication1",
            projectName: process.env.VUE_APP_COMMUNITY_NAME,
          });

          this.taskList = data.map((x) => ({
            text:
              x.name == "Sprint 0" || x.name == "Version 0"
                ? "Default"
                : x.name,
            value: x,
          }));

          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
  },

  computed: {
    ...mapState("design", ["selectedSprint", "selectedSubSprint"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("projectFile", ["selectedProjectDetails"]),
  },

  async mounted() {
    await this.getProject();
    if (this.selectedRoute == "") {
      this.handleClick(this.cards[0]);
    }
    await this.getTaskList();
    const length = this.taskList.length - 1;
    this.selectedTasklist = this.taskList[length].value;
    await this.$store.commit(
      "design/SET_SELECTED_SPRINT",
      this.selectedTasklist
    );
  },
};
</script>
